var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialfacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2609541_facebook_media_social_icon 2",
    clipPath: "url(#clip0_0_11503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36 28.6967C36 33.2855 32.3789 37 27.9211 37H8.07891C3.62109 37 0 33.2783 0 28.6967V8.30332C0 3.72168 3.62109 0 8.07891 0H27.9211C32.3789 0 36 3.72168 36 8.30332V28.6967Z",
    fill: "#4F76BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0235 11.9021C21.6282 11.8804 22.2329 11.8949 22.8375 11.8949C22.9079 11.8949 22.9852 11.8949 23.0836 11.8949V8.66459C22.7602 8.62845 22.4227 8.58509 22.0852 8.57064C21.4665 8.54173 20.8477 8.51283 20.2219 8.52728C19.2727 8.54896 18.3797 8.78744 17.5993 9.35834C16.6993 10.0232 16.2071 10.9554 16.0243 12.0538C15.9469 12.5091 15.9258 12.9788 15.9118 13.4413C15.8977 14.164 15.9118 14.8867 15.9118 15.6165V15.8911H12.9094V19.4972H15.8977V28.5593H19.5469V19.5044H22.5282C22.6829 18.3048 22.8305 17.1197 22.9852 15.8839C22.7461 15.8839 22.5282 15.8839 22.3172 15.8839C21.4665 15.8911 19.5258 15.8839 19.5258 15.8839C19.5258 15.8839 19.5329 14.099 19.554 13.3185C19.5821 12.2562 20.2008 11.931 21.0235 11.9021Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialfacebook);
export default __webpack_public_path__ + "static/media/socialfacebook.c1f89cc052a0f7e4f4de672c1c5a01d7.svg";
export { ForwardRef as ReactComponent };